import { GridCol, GridContainer, styled, useIsWindowBiggerThan } from '@bob/library'
import { MSForm } from '@websrc/App/Components/MSForm/MSForm'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { mapMSForm } from '@websrc/DataMappers/mapSpot'
import React from 'react'

export interface SpotMSFormProps {
  spot: ReturnType<typeof mapMSForm>['ms_form']
}

const StyledCol = styled(GridCol)`
  display: flex;
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px;
`

export function SpotMSForm({ spot }: SpotMSFormProps) {
  const isMobile = !useIsWindowBiggerThan(500)
  return (
    <GridContainer>
      <StyledCol {...spotWrapperProps(spot.caption)} data-testid={'caption'}>
        {!isMobile && <MSForm formScript={spot.script} />}

        {isMobile && <MSForm formScript={spot.mobile_script ? spot.mobile_script : spot.script} />}
      </StyledCol>
    </GridContainer>
  )
}
